import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { abs, breadcrumbLd, siteGraph } from "@/lib/schema";

export { breadcrumbLd };

export const Seo = ({ title, description, path = "/", crumbs, jsonLd = [], noindex = false }) => {
  const url = abs(path);
  const ld = crumbs ? [...jsonLd, breadcrumbLd(crumbs)] : jsonLd;
  useEffect(() => {
    // Remove head tags that scripts/postbuild.js pre-rendered, so the live (React-managed) tags are the only ones left.
    document.querySelectorAll("[data-static-seo]").forEach((n) => n.remove());
  }, [path]);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex ? <meta name="robots" content="noindex, follow" /> : null}
      {noindex ? null : <link rel="canonical" href={url} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ld.map((o, i) => (
        <script key={`${path}-${i}`} type="application/ld+json">{JSON.stringify(o)}</script>
      ))}
    </Helmet>
  );
};

/** Site-wide Organization + WebSite JSON-LD, rendered once from the Layout. */
export const SiteSchema = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(siteGraph())}</script>
  </Helmet>
);
